export default __webpack_public_path__ + "static/media/img13.a8d67aac.jpeg";